import axios from 'axios'

export async function signInWithPasswordAsync(
  email: string,
  password: string
): Promise<Object | null> {
  if (!email || !password) return null
  const AuthGipApiKey = import.meta.env.VITE_AUTH_GIP_API_KEY
  const AuthUrl = import.meta.env.VITE_AUTH_URL
  const url = `${AuthUrl}${AuthGipApiKey}`

  const payload = { email, password, returnSecureToken: true }
  const headers = { headers: { 'Content-Type': 'application/json' } }

  try {
    const response = await axios.post(url, payload, headers)
    const data = await response.data
    if (data.error) throw new Error(data.error.message)
    console.log('User logged in:', data.email)
    return data
  } catch (err: any) {
    console.error('Error while login:', err.message)
    throw err
  }
}
